module.exports = __webpack_public_path__ + "img/menu-button.0ea32351.svg";